const CHANNELS = ['teams', 'whatsapp', 'email'];
const USE_CASES = ['Booking Confirmation', 'Reminder', 'MOM Ready', 'Cancellation'];
const STATUSES = ['active', 'draft', 'archived'];

export const globalTemplatesList = Array.from({ length: 18 }, (_, i) => ({
  id: `gtpl-${i}`,
  name: `Global Template ${i + 1}`,
  channel: CHANNELS[i % 3],
  useCase: USE_CASES[i % 4],
  status: STATUSES[i % 7 === 0 ? 2 : i % 3],
  version: `v${1 + (i % 4)}.${i % 3}`,
  updatedAt: new Date(Date.now() - i * 86400000).toISOString(),
  bodyMarkdown:
    'Hello **{{first_name}}**, your meeting *{{meeting_title}}* starts at {{start_time}}.\n\n[Join]({{meeting_link}})',
  subject: i % 3 === 2 ? 'Meeting: {{meeting_title}}' : '',
  category: ['Sales', 'HR', 'Engineering', 'Executive'][i % 4],
  locale: i % 2 === 0 ? 'en' : 'ar',
  isDefault: i === 0,
  usageCount7d: 1200 - i * 60,
}));

const SAMPLE = {
  first_name: 'Sam',
  meeting_title: 'QBR with Acme',
  start_time: 'Tue 10:00 GST',
  duration: '45 min',
  meeting_link: 'https://meet.meetinghub.ai/x/abc',
  organizer: 'Alex Rivera',
  tenant_name: 'Acme Corp',
};

export const templateVariableList = [
  '{{first_name}}',
  '{{meeting_title}}',
  '{{start_time}}',
  '{{duration}}',
  '{{meeting_link}}',
  '{{organizer}}',
  '{{tenant_name}}',
];

export function applyTemplateSampleVars(text) {
  if (!text) return '';
  let out = text;
  Object.entries(SAMPLE).forEach(([k, v]) => {
    out = out.split(`{{${k}}}`).join(v);
  });
  return out;
}

export function buildTemplateDetail(id) {
  const idx = globalTemplatesList.findIndex((t) => t.id === id);
  const row = idx >= 0 ? globalTemplatesList[idx] : globalTemplatesList[0];
  const i = idx >= 0 ? idx : 0;
  return {
    ...row,
    validation: {
      requiredOk: true,
      variablesMapped: i % 4 !== 1,
      arabicOk: i % 5 !== 2,
    },
  };
}

export function buildTemplateVersions(templateId) {
  return Array.from({ length: 8 }, (_, i) => ({
    id: `${templateId}-ver-${8 - i}`,
    templateId,
    versionLabel: `v${8 - i}`,
    versionNum: 8 - i,
    author: `platform.admin${i}@meetinghub.ai`,
    changelog: i === 0 ? 'Initial publish' : `Tweaked section headings v${8 - i}`,
    publishedAt: new Date(Date.now() - i * 86400000 * 4).toISOString(),
    status: i === 0 ? 'current' : 'archived',
    bodyMarkdown:
      i === 0
        ? 'Hello {{first_name}},\n\nYour meeting **{{meeting_title}}** is confirmed.\n\n{{meeting_link}}'
        : `Hello {{first_name}},\n\nReminder: {{meeting_title}} at {{start_time}}.\n\nThanks,\n{{organizer}}\n\n<!-- v${8 - i} -->`,
    subject: 'Meeting: {{meeting_title}}',
  }));
}

/** @deprecated use buildTemplateVersions */
export const templateVersions = buildTemplateVersions('gtpl-0');
